import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { Loader2, CheckCircle2 } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * /demo-invite/:token — public landing page.
 * Auto-redeems the invite and logs the prospect in as a demo teacher.
 */
export default function DemoInviteRedeem() {
  const { token } = useParams();
  const nav = useNavigate();
  const [status, setStatus] = useState('loading');
  const [err, setErr] = useState('');
  const [info, setInfo] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const r = await axios.get(`${API}/api/demo-invites/${token}/redeem`);
        localStorage.setItem('session_token', r.data.session_token);
        localStorage.setItem('user', JSON.stringify(r.data.user));
        setInfo(r.data);
        setStatus('success');
        setTimeout(() => nav('/teacher-dashboard', { replace: true }), 1800);
      } catch (e) {
        setErr(e.response?.data?.detail || 'This invite link is no longer valid.');
        setStatus('error');
      }
    })();
  }, [token, nav]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center" data-testid="demo-invite-redeem">
        {status === 'loading' && (
          <>
            <Loader2 className="animate-spin mx-auto text-blue-600" size={40} />
            <h1 className="mt-4 text-xl font-semibold text-slate-900">Preparing your MOSAIC demo…</h1>
            <p className="mt-2 text-sm text-slate-600">One moment while we set up your preview account.</p>
          </>
        )}
        {status === 'success' && info && (
          <>
            <CheckCircle2 className="mx-auto text-emerald-500" size={48} />
            <h1 className="mt-4 text-xl font-semibold text-slate-900">Welcome, {info.user.name}!</h1>
            <p className="mt-2 text-sm text-slate-600">
              You're logged in as a preview teacher for grade band <b>{info.invite.grade_band}</b>.
              {info.invite.created_by_name && <> Invited by <b>{info.invite.created_by_name}</b>.</>}
            </p>
            <p className="mt-4 text-xs text-slate-400">Redirecting to the teacher dashboard…</p>
          </>
        )}
        {status === 'error' && (
          <>
            <div className="text-4xl">😕</div>
            <h1 className="mt-4 text-xl font-semibold text-slate-900">Invite unavailable</h1>
            <p className="mt-2 text-sm text-slate-600">{err}</p>
            <p className="mt-4 text-xs text-slate-500">Please contact your MOSAIC sales representative for a new link.</p>
          </>
        )}
      </div>
    </div>
  );
}
